import { AnimationHandler } from "./AnimationHandler";
//import { ArcCamera } from "./arcCamera";
import { CameraSettings, VariantsSettings, ViewDetails } from "./view";
import { VariantsHandler } from "./VariantsHandler";
import "@babylonjs/loaders/glTF";
import { LightHandler } from "./LightHandler";
import { ReflectionHandler } from "./Reflectionhandler";
import {
    AnimationGroup,
    Light,
    ShadowGenerator,
    IShadowLight,
    SceneLoader,
    Mesh,
    //DirectionalLight,
    MirrorTexture,
    BackgroundMaterial,
    computeMaxExtents,
    ArcRotateCamera,
    FramingBehavior,
    SpotLight
} from "@babylonjs/core";

import { Texture } from "@babylonjs/core/Materials/Textures/texture";
import { Color3, Plane, Vector3 } from "@babylonjs/core/Maths/math";
import { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";
import { GLTF2, } from "@babylonjs/loaders/glTF";
import { GLTFLoader } from "@babylonjs/loaders/glTF/2.0";
import { IBCADDY_external_model } from "./IBCADDY_external_model";
import { JsonDB } from "./JsonDB";
import { CaseInsensitiveMap } from "./CaseInsensitiveMap";
//import Emittery from "emittery";
import { CameraHandler } from "./cameraHandler";

export class ModelLoader {
    //TODO: remove Model map and make root node "Models" where all loaded models reside. string key is then node.ID
    //doing this would then simplify some code in this class (turntable for example)
    //public Model:Map<string,AbstractMesh[]> = new Map();
    //public ModelFullPat: Map<string, number> = new Map();

    //public Notify: Emittery = new Emittery();
    public Ground: AbstractMesh;
    public Animations: AnimationGroup[] = [];
    public VariantHandler: Map<string, VariantsHandler> = new Map();
    public MaterialTags: CaseInsensitiveMap<AbstractMesh[]> = new CaseInsensitiveMap();
    public CurrentMaterialTags: CaseInsensitiveMap<string> = new CaseInsensitiveMap();
    public CurrentGroups: CaseInsensitiveMap<string> = new CaseInsensitiveMap();
    //public ArcCamera: ArcCamera;
    public AnimationHandler: AnimationHandler;
    public Camerahandler: CameraHandler;
    public LightSources: Light[];
    public LightHandler: LightHandler;
    public ShadowGenerator: ShadowGenerator;
    public LoadingTop: boolean = false;
    public Reflectionhandler: ReflectionHandler;
    public IBCADDY_external_model: IBCADDY_external_model[] = [];
    public JsonDB: JsonDB;
    private _dbJson: string;


    public LoadingQue: [];

    public LoadingDiv: HTMLDivElement;
    public LoadingAnimation: HTMLImageElement;
    public AllComponentsFilePath: string[] = [];

    // private _camera:Camera;
    // private _scene:Scene;
    // private _view:View; 

    private _details: ViewDetails;
    private isLoading: boolean = false;
    //private _maxVector: Vector3;
    //private _minVector: Vector3;
    private _variantData: VariantsSettings;
    private _singleRepeat: boolean;
    private backgroundMaterial: BackgroundMaterial;
    //public light: DirectionalLight;
    public light: SpotLight;

    private _loadingAnimationPath: string = "";
    private _loadingBackground: string = "";
    private _showLoading: boolean;
    public GroundPlane: Mesh;

    private _ground: boolean = false;
    private _groundY: number = 0;
    private _groundScale: number = 10;
    private _groundColor: string

    private _loadingAnimationWidth: number = 100;
    private _loadingAnimationHeight: number = 100;
    private _loadingAnimationTop: number = 50;
    private _loadingAnimationLeft: number = 50;
    private _modelScale: number = 1;
    public _modelPath: string;
    private _shadows: boolean;
    private _reflections: boolean;

    public log: HTMLElement;

    constructor(
        VariantData: VariantsSettings,
        cameraData: CameraSettings,
        singleRepeatAnimation: boolean,
        details: ViewDetails
        // scene: Scene,
        // camera: Camera,
        // view: View
    ) {
        this._details = details;
        this._variantData = VariantData;
        this._singleRepeat = singleRepeatAnimation;
        this.Reflectionhandler = new ReflectionHandler(details.scene);
        this.AnimationHandler = new AnimationHandler(details.scene);

        //TODO: move to view details        
        //this.light = new DirectionalLight("light1", new Vector3(-1, -3, 1), details.scene);

        //iso left
        const n = Math.sqrt(3.0)/3.0;
        const lightDirection = new Vector3(n, -n, n);

        this.light = new SpotLight(
            "light1",
            new Vector3(0, 5, 0),
            lightDirection,
            5 * Math.PI / 6,
            1,
            details.scene
            );

        //this.light.position = new Vector3(10, 30, 10);
        this.light.intensity = 5; //0.7;
        this.light.shadowMaxZ = 100;
        this.light.shadowMinZ = 1;

        this.backgroundMaterial = new BackgroundMaterial("backgroundMaterial", details.scene);
        this.backgroundMaterial.primaryColor = new Color3(1, 1, 1);
        this.backgroundMaterial.allowShaderHotSwapping = true;
        this.JsonDB = new JsonDB();
        this.Camerahandler = new CameraHandler(details, this.AnimationHandler);
        details.view.notify.emit("modelLoaderReady");
    }

    async LoadAsyncPerComponent(path: string): Promise<boolean> {

        console.log("Loading" + path);
        this.JsonDB = new JsonDB();

        console.log("With JSON database " + this.DBJson);

        await this.JsonDB.ReadJson(this.DBJson);

        console.log("Default materials tags " + this.JsonDB.DefaultMaterialTag)
        //console.log("With JSON database " + this.JsonDB.MaterialTag)


        GLTF2.GLTFLoader.RegisterExtension('IBCADDY_external_model', (loader: GLTFLoader) =>
            new IBCADDY_external_model(loader, this._details.scene, this, this.JsonDB)
        );

        console.log('IBCADDY_external_model Registerd')

        try {
            const result = await SceneLoader.ImportMeshAsync("", path);
            console.log(result)

            result.transformNodes.forEach(element => {
                if (element.name !== "Cameras") {
                    this._details.scene.removeTransformNode(element);
                }
            });

            (this._details.camera as ArcRotateCamera).lowerRadiusLimit = 0;
            (this._details.camera as ArcRotateCamera).zoomOn(result.meshes, true);
            (this._details.camera as ArcRotateCamera).wheelPrecision = 200;


            // Wait until IBCADDY_external_model array is empty
            while (this.IBCADDY_external_model.length > 0) {
                await new Promise(resolve => setTimeout(resolve, 100)); // Check every 100ms
            }

            this._details.view.notify.emit("modelPerComponentLoaded");

            return true;
        } catch (error) {
            console.error("Error during LoadAsyncPerComponent:", error);
            return false;
        }
    }

    public GetModelById(id: string): AbstractMesh {
        const model = this._details.models.getChildMeshes(true).find(
            (model) => {
                return model.id === id;
            }
        );

        return model;
    }

    public GetNumModels(): number {
        return this._details.models.getChildMeshes(true).length;
    }

    async LoadAsyncModelNoClear(path: string): Promise<AbstractMesh> {
        if (!this.isLoading) {
            this.LoadLoading()
            this.isLoading = true;
        }

        let loaderResult;
        try {
            loaderResult = await SceneLoader.ImportMeshAsync(undefined, path, undefined, this._details.scene);
        }
        catch (err) {
            console.error('An ImportMeshAsync error occurred:', err);
            throw err;
        }

        const modelId = this.addIndexIfExists(this._details.view.GetFilenameFromUri(path))
        const model = loaderResult.meshes[0];
        model.id = modelId;
        model.parent = this._details.models;

        this.VariantHandler.set(this._details.view.GetFilenameFromUri(path), new VariantsHandler(loaderResult.meshes[0] as Mesh))
        this.Animations = loaderResult.animationGroups;
        for (let i = 0; i < loaderResult.transformNodes.length; i++) {
            if (loaderResult.transformNodes[i].animations != null) {
                if (loaderResult.transformNodes[i].animations.length > 0) {
                    for (let j = 0; j < loaderResult.transformNodes[i].animations.length; j++) {
                        if (loaderResult.transformNodes[i].animations[j].getKeys().length > 2) {
                            if (this.AnimationHandler.MeshesWithAnimations)
                                this.AnimationHandler.MeshesWithAnimations.push(loaderResult.transformNodes[i]);
                        }
                        break;
                    }
                }
            }
        }
        this.Camerahandler = new CameraHandler(this._details, this.AnimationHandler);
        this.CenterModel();
        //(this._details.camera as ArcRotateCamera).zoomOn(loaderResult.meshes, true)
        if (this.isLoading) {
            this.DeleteLoadingScreen()
            this.isLoading = false;
        }

        this._details.view.notify.emit("modelLoaded");

        return loaderResult.meshes[0]
    }

    async LoadAsyncModelNoClearNoLoading(path: string, centerModel?: boolean): Promise<AbstractMesh> {

        if (centerModel == undefined)
            centerModel = true;

        if (!this.isLoading)
            this.isLoading = true;

        let loaderResult;
        try {
            loaderResult = await SceneLoader.ImportMeshAsync(undefined, path, undefined, this._details.scene);
        }
        catch (err) {
            console.error('An ImportMeshAsync error occurred:', err);
            throw err;
        }

        const modelId = this._details.view.GetFilenameFromUri(path);

        const newModel = loaderResult.meshes[0];
        newModel.id = modelId;

        const oldModel = this.GetModelById(modelId);
        if (oldModel)
            newModel.id = modelId + this.GetNumModels();

        newModel.parent = this._details.models;

        // if(!this.Model.has(this._details.view.GetFilenameFromUri(path)))
        //     this.Model.set(this._details.view.GetFilenameFromUri(path),result.meshes)
        // else
        //     this.Model.set(this._details.view.GetFilenameFromUri(path)+this.Model.size,result.meshes)
        this.VariantHandler.set(
            this._details.view.GetFilenameFromUri(path),
            new VariantsHandler(newModel as Mesh)
        );

        this.Animations = loaderResult.animationGroups;
        for (let i = 0; i < loaderResult.transformNodes.length; i++) {
            if (loaderResult.transformNodes[i].animations != null) {
                if (loaderResult.transformNodes[i].animations.length > 0) {
                    for (let j = 0; j < loaderResult.transformNodes[i].animations.length; j++) {
                        if (loaderResult.transformNodes[i].animations[j].getKeys().length > 2) {
                            if (this.AnimationHandler.MeshesWithAnimations)
                                this.AnimationHandler.MeshesWithAnimations.push(loaderResult.transformNodes[i]);
                        }
                        break;
                    }
                }
            }
        }
        this.Camerahandler = new CameraHandler(this._details, this.AnimationHandler);
        if (centerModel)
            this.CenterModel();

        if (this.isLoading) {
            this.isLoading = false;
        }
        return newModel;
    }

    async LoadGroundAsync(path: string): Promise<boolean> {
        if (!this.isLoading) {
            this.LoadLoadingScreen()
            this.isLoading = true;
        }
        const result = await SceneLoader.ImportMeshAsync("", path)
        this.Ground = result.meshes[0];
        this.Camerahandler = new CameraHandler(this._details, this.AnimationHandler);

        for (let i = 0; i < result.meshes.length; i++)
            result.meshes[i].receiveShadows = true;
        if (this.isLoading) {
            this.DeleteLoadingScreen()
            this.isLoading = false;
        }
        this.Camerahandler = new CameraHandler(this._details, this.AnimationHandler);
        return true;
    
    }


    ZoomOnModel() {

        //this.Camerahandler.ActiveCamera = 0;
        if (this._details.scene.activeCamera instanceof ArcRotateCamera )
        {
            const activeArcRotateCamera = this._details.scene.activeCamera as ArcRotateCamera;
            activeArcRotateCamera.zoomOn(this._details.models.getChildMeshes());
        }
    }
    CenterModel() {
        let radius = 1;
        if (this._details.models) {
            // get bounds and prepare framing/camera radius from its values
            this._details.camera.lowerRadiusLimit = null;
            
            const maxExtents = computeMaxExtents(this._details.models.getChildMeshes()/*, this._activeAnimation*/);
            const worldExtents = {
                min: new Vector3(Math.min(...maxExtents.map((e) => e.minimum.x)), Math.min(...maxExtents.map((e) => e.minimum.y)), Math.min(...maxExtents.map((e) => e.minimum.z))),
                max: new Vector3(Math.max(...maxExtents.map((e) => e.maximum.x)), Math.max(...maxExtents.map((e) => e.maximum.y)), Math.max(...maxExtents.map((e) => e.maximum.z))),
            };

            const framingBehavior = this._details.camera.getBehaviorByName("Framing") as FramingBehavior;
            framingBehavior.zoomOnBoundingInfo(worldExtents.min, worldExtents.max);

            const worldSize = worldExtents.max.subtract(worldExtents.min);
            const worldCenter = worldExtents.min.add(worldSize.scale(0.5));

            radius = worldSize.length() * 1.1;

            if (!isFinite(radius)) {
                radius = 1;
                worldCenter.copyFromFloats(0, 0, 0);
            }

            this._details.view.ArcCamera.CenterModel(worldCenter);

            this._details.camera.lowerRadiusLimit = radius * 0.01;
            this._details.camera.wheelPrecision = 100 / radius;
            this._details.camera.alpha = Math.PI / 2;
            this._details.camera.beta = Math.PI / 2.4;
            this._details.camera.radius = radius;
            this._details.camera.minZ = radius * 0.01;
            this._details.camera.maxZ = radius * 1000;
            this._details.camera.speed = radius * 0.2;
            //this._details.camera.useAutoRotationBehavior = true;
            this._details.camera.pinchPrecision = 200 / this._details.camera.radius;
            this._details.camera.upperRadiusLimit = 5 * this._details.camera.radius;
            this._details.camera.wheelDeltaPercentage = 0.01;
            this._details.camera.pinchDeltaPercentage = 0.01;
            this._details.camera.restoreStateInterpolationFactor = 0.1;
            this._details.camera.storeState();

        }

        // const maxExtents = computeMaxExtents([this._details.models]/*, this._activeAnimation*/);
        // const worldExtents = {
        //     min: new Vector3(Math.min(...maxExtents.map((e) => e.minimum.x)), Math.min(...maxExtents.map((e) => e.minimum.y)), Math.min(...maxExtents.map((e) => e.minimum.z))),
        //     max: new Vector3(Math.max(...maxExtents.map((e) => e.maximum.x)), Math.max(...maxExtents.map((e) => e.maximum.y)), Math.max(...maxExtents.map((e) => e.maximum.z))),
        // };

        // const maxVector = new Vector3(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        // const minVector = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        // this._details.models.getChildMeshes().forEach((model)=>{
        //     //for(let j=0;j<value.length;j++)
        //     {
        //         const GLTFmeshVectorMin = model.getBoundingInfo().boundingBox.minimumWorld;
        //         const GLTFmeshVectorMax = model.getBoundingInfo().boundingBox.maximumWorld;
        //         if (GLTFmeshVectorMin.x < minVector.x)
        //             minVector.x = GLTFmeshVectorMin.x
        //         if (GLTFmeshVectorMin.y < minVector.y)
        //             minVector.y = GLTFmeshVectorMin.y
        //         if (GLTFmeshVectorMin.z < minVector.z)
        //             minVector.z = GLTFmeshVectorMin.z
        //         if (GLTFmeshVectorMax.x > maxVector.x)
        //             maxVector.x = GLTFmeshVectorMax.x
        //         if (GLTFmeshVectorMax.y > maxVector.y)
        //             maxVector.y = GLTFmeshVectorMax.y
        //         if (GLTFmeshVectorMax.z > maxVector.z)
        //             maxVector.z = GLTFmeshVectorMax.z
        //     }
        // })
        // //this._minVector = minVector;
        // //this._maxVector = maxVector;
        // const minMaxVector = maxVector.subtract(minVector)
        // const center = minVector.add(minMaxVector.scale(0.5));

        // this._details.view.ArcCamera.CenterModel(center);
    }

    public GenerateShadows(light: number) {
        const createShadowGenerator = () => {
            
            const shadowGen = new ShadowGenerator(2048, this._details.scene.lights[light] as IShadowLight); // Increased resolution
            //shadowGen.usePercentageCloserFiltering = true;
            shadowGen.filter = ShadowGenerator.FILTER_PCF;
            shadowGen.filteringQuality = ShadowGenerator.QUALITY_HIGH;
            //shadowGen.frustumEdgeFalloff = 0.5;
            shadowGen.forceBackFacesOnly = true;
            shadowGen.bias = 0.0001; // Adjusted bias
            //shadowGen.normalBias = 0.001; // Adjusted normal bias
            shadowGen.normalBias = 0.02; // Adjusted normal bias
            
            //only for FILTER_PCSS
            shadowGen.useContactHardeningShadow = true;
            shadowGen.contactHardeningLightSizeUVRatio = 0.1; // Increased ratio for softer shadows

            shadowGen.setDarkness(0.1);

            shadowGen.addShadowCaster(this._details.models);
            this._details.models.receiveShadows = true;

            return shadowGen;
        };

        if (this.ShadowGenerator == null) {
            this.ShadowGenerator = createShadowGenerator();
        } else {
            this.ShadowGenerator.dispose();
            this.ShadowGenerator = createShadowGenerator();
        }
    }



    public DeleteModel(nameId: string, centerModel?: boolean) {
        //const model =  this.Model.get(name);

        if (centerModel == undefined)
            centerModel = true;

        const model = this.GetModelById(nameId);
        if (model) {
            this._details.models.removeChild(model);
            model.dispose();
            //this._details.scene.removeMesh(model, true);
            //model.parent = null;
            if (centerModel)
                this.CenterModel();
        }
    }

    public LoadLoadingScreen() {
        this._details.view.Engine.resize();
        if (this.LoadingDiv != null) {
            this.DeleteLoadingScreen();
        }
        this.LoadingDiv = document.createElement("div");
        this.LoadingDiv.style.width = this._details.view.Canvas.width.toString() + "px";
        this.LoadingDiv.style.height = this._details.view.Canvas.height.toString() + "px";
        this.LoadingDiv.style.backgroundColor = "#000000";
        this.LoadingDiv.style.position = "absolute"
        this.LoadingDiv.style.zIndex = "5"
        if (!this.LoadingTop)
            this.LoadingDiv.style.top = "0px"
        else
            this.LoadingDiv.style.top = (this._details.view.Canvas.getBoundingClientRect().top + window.scrollY).toString() + "px"
        this._details.view.Canvas.parentElement.appendChild(this.LoadingDiv)
        this.LoadingAnimation = document.createElement("img");
        if (this._loadingAnimationPath == null || this._loadingAnimationPath == '')
            this.LoadingAnimation.src = this._details.view.ResolveAssetsPath("./assets/Default/Loading/Loading.gif");
        else
            this.LoadingAnimation.src = this._loadingAnimationPath
        this.LoadingAnimation.style.width = this.LoadingAnimationWidht.toString() + "px";
        this.LoadingAnimation.style.height = this.LoadingAnimationHeight.toString() + "px";
        if (this._loadingBackground == null || this._loadingBackground == '')
            this.LoadingDiv.style.backgroundColor = "#000000";
        else
            this.LoadingDiv.style.backgroundColor = this._loadingBackground;
        this.LoadingAnimation.style.position = "absolute"
        this.LoadingAnimation.style.top = (this._details.view.Canvas.height / 2 - this.LoadingAnimationHeight / 2).toString() + "px"
        this.LoadingAnimation.style.left = (this._details.view.Canvas.width / 2 - this.LoadingAnimationWidht / 2).toString() + "px"
        this.LoadingAnimation.style.zIndex = "5"
        this.LoadingDiv.appendChild(this.LoadingAnimation)
    }
    public LoadLOG(LOG: string) {
        if (this.log == null) {
            this.log = document.createElement("h1");
            this.LoadingDiv.style.width = this._details.view.Canvas.width.toString() + "px";
            this.log.style.position = "absolute"
            this.log.style.textAlign = "center";
            this.log.style.zIndex = "2";
            this.log.style.color = "white"
            this.log.style.top = (this._details.view.Canvas.height / 2 - this.LoadingAnimationHeight / 2).toString() + "px"
            this.log.style.left = (this._details.view.Canvas.width / 2 - this.LoadingAnimationWidht / 2).toString() + "px"
            this._details.view.Canvas.parentElement.appendChild(this.log)
        }
        this.log.textContent = LOG




    }
    public LoadLoading() {
        this._details.view.Engine.resize();
        if (this.LoadingDiv != null) {
            this.DeleteLoadingScreen();
        }
        this.LoadingAnimation = document.createElement("img");
        if (this._loadingAnimationPath == null || this._loadingAnimationPath == '')
            this.LoadingAnimation.src = this._details.view.ResolveAssetsPath("./assets/Default/Loading/Loading.gif");
        else
            this.LoadingAnimation.src = this._loadingAnimationPath
        this.LoadingAnimation.style.width = this.LoadingAnimationWidht.toString() + "px";
        this.LoadingAnimation.style.height = this.LoadingAnimationHeight.toString() + "px";
        this.LoadingAnimation.style.position = "absolute"
        this.LoadingAnimation.style.top = (this._details.view.Canvas.height / 2 - this.LoadingAnimationHeight / 2).toString() + "px"
        this.LoadingAnimation.style.left = (this._details.view.Canvas.width / 2 - this.LoadingAnimationWidht / 2).toString() + "px"
        this._details.view.Canvas.parentElement.appendChild(this.LoadingAnimation)
    }
    public DeleteLoadingScreen() {
        if (this.LoadingDiv)
            this.LoadingDiv.remove()
        if (this.LoadingAnimation)
            this.LoadingAnimation.remove()
        this.LoadingDiv = null;
        this.LoadingAnimation = null;
        this.AnimationHandler.DrawHotSpotTimeout(20000);
    }

    public CreateReflection() {
        const mirror = new MirrorTexture("mirror", 1024, this._details.scene);
        mirror.mirrorPlane = new Plane(0, -1, 0, 0);

        // this._details.models.getChildMeshes().forEach((model)=>{
        //     mirror.renderList.push(model);
        // });
        // for (const [, elements] of this.Model.entries()) {
        //     elements.forEach(element => {
        //         mirror.renderList.push(element);
        //     });
        // }
        mirror.renderList.push(this._details.models);

        this.backgroundMaterial.reflectionTexture = mirror;
        this.backgroundMaterial.reflectionFresnel = true;
        this.backgroundMaterial.reflectionStandardFresnelWeight = 0.8;

        this.GroundPlane.material = this.backgroundMaterial;
    }
    public ImportReflectionTexture(path: string): Texture {
        const text = new Texture(path)
        text.coordinatesMode = Texture.EQUIRECTANGULAR_MODE
        return text;
    }

    private addIndexIfExists(str: string): string {
        if (this.IBCADDY_external_model.length > 0) {
            console.log(str + " ExternalModel > 0")
            return str;
        }

        let index = 0;
        let newString = str + index;
        while (this.GetModelById(newString)) {
            index++;
            newString = `${str}${index}`;
        }
        return newString;
    }

    public async ReplaceModel(oldModelFile: string, newModelPath: string): Promise<boolean> {
        //fetchFileUrl ???
        const newModelFile = this._details.view.GetFilenameFromUri(newModelPath);

        const group = this.CurrentGroups.get(oldModelFile);
        if (group) //oldModel is a component in group
        {
            this.CurrentGroups.delete(oldModelFile);
            this.CurrentGroups.set(newModelFile, group);
            this._details.view.notify.emit("priceAttributeChanged", this.GetSKU());
        }

        let newModel: AbstractMesh = this.GetModelById(newModelFile);

        //if  (this.Model.has(newModelFile))
        //    newModel = this.Model.get(newModelFile)[0];

        this._details.view.StopTurntableAnimation();

        if (!newModel)
            newModel = await this.LoadAsyncModelNoClearNoLoading(this._details.view.ResolveDataPath(newModelPath), false);
        else {
            //from cache, just enable
            newModel.setEnabled(true);
            newModel.getChildMeshes(false).forEach((c) => c.setEnabled(true));
        }

        //const oldModel = this.Model.get(oldModelFile)[0];
        const oldModel = this.GetModelById(oldModelFile);
        //find in scene

        newModel.position = oldModel.position;
        newModel.rotation = oldModel.rotation;

        //only disable old node
        oldModel.setEnabled(false);
        oldModel.getChildMeshes(false).forEach((c) => c.setEnabled(false));
        //this._details.scene.removeMesh(oldModel,true);        
        //do not remove, use it as a cache
        //this.Model.delete(oldModelFile)

        this.Shadows = this._shadows;
        this.Reflections = this._reflections;

        return true

    }

    public async ReplaceModelPerComponent(name: string, newModel: string) {
        const model = this.GetModelById(newModel);
        if (!model) {
            const modelPath = await this.fetchFileUrl(newModel)
            this.LoadAsyncModelNoClearNoLoading(modelPath, false).then(() => {
                this.DeleteModel(name, false);
                this.UpdateMaterials();
            });
        }
    }
    public UpdateMaterials() {
        const oldTags = new Map(this.MaterialTags);
        this.SortMaterialTags();
        for (const key of this.MaterialTags.keys()) {
            for (let i = 0; i < this.MaterialTags.get(key).length; i++) {
                if (this.MaterialTags.get(key)[i].material.name == key) {
                    this.MaterialTags.get(key)[i].material = oldTags.get(key)[0].material
                }
            }
        }
    }
    public SortMaterialTags() {
        const meshes = this._details.scene.meshes
        for (let i = 0; i < this._details.scene.materials.length; i++) {
            const meshesWithMat = []
            for (let j = 0; j < meshes.length; j++) {
                if (meshes[j].material?.name == this._details.scene.materials[i].name) {
                    if (this.MaterialTags.get(this._details.scene.materials[i].name)) {
                        this.MaterialTags.get(this._details.scene.materials[i].name).push(meshes[j])
                    }
                    else
                        meshesWithMat.push(meshes[j])
                }

            }
            if (this.JsonDB.DefaultMaterialTag.get(this._details.scene.materials[i].name)) {
                if (!this.MaterialTags.get(this._details.scene.materials[i].name))
                    this.MaterialTags.set(this._details.scene.materials[i].name, meshesWithMat);
            }
        }
    }

    public GetSKU(): string {
        for (const attribure of this.JsonDB.Attributes) {
            const tagValue = this.CurrentMaterialTags.get(attribure.tag);
            if (tagValue && tagValue.toLowerCase() == attribure.tagValue.toLowerCase()) //tag/tagValue match
            {
                const group = this.CurrentGroups.get(attribure.groupValue);
                if (group && group.toLowerCase() == attribure.group.toLowerCase()) //group/groupValue match
                    return attribure.SKU;
            }
        }
        return "";
    }

    public LoadMaterial(url: string, matToReplace: string, isGlass?: boolean) {
        if (this.MaterialTags.size < 3)
            this.SortMaterialTags()

        const path = this._details.view.ResolveDataPath(url);
        SceneLoader.LoadAssetContainerAsync(path).then((result) => {
            if (this.MaterialTags.get(matToReplace)) {
                const tagValue = this._details.view.GetFilenameFromUri(path);

                this.CurrentMaterialTags.set(matToReplace, tagValue);
                this._details.view.notify.emit("priceAttributeChanged", this.GetSKU());
                this.MaterialTags.get(matToReplace).forEach(element => {

                    //we must preserve old texture matrix
                    let uOffset: number = 0;
                    let vOffset: number = 0;
                    let uScale: number = 1;
                    let vScale: number = 1;
                    let uAng: number = 0;
                    let vAng: number = 0;
                    let wAng: number = 0;
                    const oldBaseTextures = element.material.getActiveTextures();
                    for (const oldBaseTexture of oldBaseTextures) {
                        if (!oldBaseTexture.getTextureMatrix().isIdentity()) {
                            const oldTexture = oldBaseTexture as Texture;
                            uOffset = oldTexture.uOffset;
                            vOffset = oldTexture.vOffset;
                            uScale = oldTexture.uScale;
                            vScale = oldTexture.vScale;
                            uAng = oldTexture.uAng;
                            vAng = oldTexture.vAng;
                            wAng = oldTexture.wAng;
                            break;
                        }
                    }

                    element.material = result.materials[0];

                    if (isGlass) {
                        element.material.alpha = 0;
                        element.material.transparencyMode = 2
                        element.material.needDepthPrePass = true;
                        element.material.alphaMode = 5;
                    }

                    //restore texture matrix
                    const newBaseTextures = element.material.getActiveTextures();
                    for (const newBaseTexture of newBaseTextures) {
                        const newTexture = newBaseTexture as Texture;
                        newTexture.uOffset = uOffset;
                        newTexture.vOffset = vOffset;
                        newTexture.uScale = uScale;
                        newTexture.vScale = vScale;
                        newTexture.uAng = uAng;
                        newTexture.vAng = vAng;
                        newTexture.wAng = wAng;
                    }

                });
            }

        }, () => {
            console.error("Material IS NOT SUPPORTED")
        });
    }

    public async fetchFileUrl(filename: string): Promise<string> {
        //NOTE: recursive search might not be neede since getDataPath might do the job anyway
        const response = await fetch(`/wp-json/devev/v1/file-url?filename=${filename}`);
        const data = await response.json();
        return data;
        //return this.getDataPath(filename);
    }
    public async getSpecificFileUrlByTitle(filename: string, postType: string = 'attachment', postsPerPage: number = 1): Promise<string> {
        const response = await fetch(`/wp-json/custom/v1/devev?filename=${encodeURIComponent(filename)}&post_type=${encodeURIComponent(postType)}&posts_per_page=${postsPerPage}`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    }



    public TransformModel(model: string, x: number, y: number, z: number, scale: number) {
        const modelRoot = this.GetModelById(model); //this.Model.get(model)[0]
        modelRoot.setAbsolutePosition(new Vector3(x, y, z));
        modelRoot.scaling = new Vector3(scale, scale, scale);
        this.CenterModel();
    }

    public get LoadingAnimationPath(): string { return this._loadingAnimationPath; }
    public set LoadingAnimationPath(value: string) {
        this._loadingAnimationPath = value;
        if (this.LoadingAnimation != null)
            this.LoadingAnimation.src = this._loadingAnimationPath
    }
    public get LoadingBackground(): string { return this._loadingBackground; }
    public set LoadingBackground(value: string) {
        this._loadingBackground = value;
        if (this.LoadingDiv != null)
            this.LoadingDiv.style.backgroundColor = this._loadingBackground;
    }
    public get ShowLoading(): boolean { return this._showLoading; }
    public set ShowLoading(value: boolean) {
        this._showLoading = value;
        if (this._showLoading)
            this.LoadLoadingScreen();
        else if (this.LoadingDiv != null)
            this.DeleteLoadingScreen();
    }
    public get LoadingAnimationWidht(): number { return this._loadingAnimationWidth; }
    public set LoadingAnimationWidht(value: number) {
        this._loadingAnimationWidth = value
        if (this.LoadingAnimation != null)
            this.LoadingAnimation.style.width = this._loadingAnimationWidth.toString() + "px"
    }
    public get LoadingAnimationHeight(): number { return this._loadingAnimationHeight; }
    public set LoadingAnimationHeight(value: number) {
        this._loadingAnimationHeight = value
        if (this.LoadingAnimation != null)
            this.LoadingAnimation.style.height = this._loadingAnimationHeight.toString() + "px"
    }
    public get LoadingAnimationTop(): number { return this._loadingAnimationTop; }
    public set LoadingAnimationTop(value: number) {
        this._loadingAnimationTop = value
        if (this.LoadingAnimation != null) {
            this.LoadingAnimation.style.top = ((this._details.view.Canvas.height - this._loadingAnimationHeight) * this._loadingAnimationTop / 100).toString() + "px"
        }
    }
    public get LoadingAnimationLeft(): number { return this._loadingAnimationLeft; }
    public set LoadingAnimationLeft(value: number) {
        this._loadingAnimationLeft = value
        if (this.LoadingAnimation != null) {
            this.LoadingAnimation.style.left = ((this._details.view.Canvas.height - this._loadingAnimationWidth) * this._loadingAnimationLeft / 100).toString() + "px"
        }
    }
    public get ModelPath(): string { return this._modelPath; }
    public set ModelPath(value: string) {
        if (value != null)
            this._modelPath = value
    }
    public get Reflections(): boolean { return this._reflections; }
    public set Reflections(value: boolean) {
        this._reflections = value;
        if (this._reflections)
            this.CreateReflection();
        else
            this.backgroundMaterial.reflectionTexture = null;
    }
    
    public get Shadows(): boolean { return this._shadows; }
    public set Shadows(value: boolean) {
        this._shadows = value;
        if (this._shadows)
            this.GenerateShadows(0);
        else
            if (this.ShadowGenerator != null) {
                this._details.models.receiveShadows = false;
                this.ShadowGenerator.dispose()
                this.ShadowGenerator = null;
            }
    }
    public get DBJson(): string { return this._dbJson; }
    public set DBJson(value: string) {
        if (value)
            this._dbJson = value;
    }

    public get GroundEnable(): boolean { return this._ground; }
    public set GroundEnable(value: boolean) {
        this._ground = value;
        if (this._ground) {
            this.GroundPlane = Mesh.CreateGround("ground1", 100, 100, 2, this._details.scene);
            this.GroundPlane.position.y = this._groundY;
            this.GroundPlane.scaling = new Vector3(this._groundScale, 1, this._groundScale);
            this.GroundPlane.receiveShadows = true;
            this.GroundPlane.material = this.backgroundMaterial;
        }
        else
            this._details.scene.removeMesh(this.GroundPlane);
    }
    public get GroundY(): number { return this._groundY; }
    public set GroundY(value: number) {
        this._groundY = value
        if (this._ground)
            this.GroundPlane.position.y = this._groundY;

    }
    public get GroundScale(): number { return this._groundScale; }
    public set GroundScale(value: number) {
        this._groundScale = value
        if (this._ground)
            this.GroundPlane.scaling = new Vector3(this._groundScale, 1, this._groundScale);

    }
    convertHex(hex: string): Color3 {
        // Remove the hash at the start if it's there
        hex = hex.replace(/^#/, '');

        // Parse the r, g, b values
        const r = parseInt(hex.substring(0, 2), 16) / 255;
        const g = parseInt(hex.substring(2, 4), 16) / 255;
        const b = parseInt(hex.substring(4, 6), 16) / 255;

        // Return the Color4 object with alpha set to 1
        return new Color3(r, g, b);
    }
    public get GroundColor(): string { return this._groundColor; }
    public set GroudColor(value: string) {
        if (value) {
            this._groundColor = value
            this.backgroundMaterial = new BackgroundMaterial("backgroundMaterial", this._details.scene);
            this.GroundPlane.material = this.backgroundMaterial;
        }
    }

}
